import angular from 'angular'

import ggsAttr from '../../ggs-attr'
import ggsUtils from '../../utils'
import ggsFrame from '../../ggs-frame'
import ggsAnimate from '../../ggs-animate'
import ggsSpinner from '../../ggs-spinner'
import ggsVisible from '../../ggs-visible'
import ggsImgQueue from '../../ggs-img-queue'
import ggsHtmlPlayer from '../../ggs-html-player'
import ggsRecalcOnevent from '../../ggs-recalc-onevent'
import ggsElementPosition from '../../ggs-element-position'
import ggsGalleryRetry from '../../gallery-retry'

export default angular
  .module('ggs.gallery-embed', [
    ggsAttr,
    ggsUtils,
    ggsFrame,
    ggsAnimate,
    ggsSpinner,
    ggsVisible,
    ggsImgQueue,
    ggsHtmlPlayer,
    ggsRecalcOnevent,
    ggsElementPosition,
    ggsGalleryRetry
  ])
  .name
